import ko from "knockout";
import $ from "jquery";

/*import * as Ladda from 'ladda';*/

import config from "./app/config.js";

import { Segment } from "./common/tracking.js"

//todo: sh.sergey - divide global.js to app models and utilities, then import utilities with this function
function getQueryParam(name, url) {
    if (!url) url = location.href;
    name = name.replace(/[\[]/, "\\\[").replace(/[\]]/, "\\\]");
    var regexS = "[\\?&]" + name + "=([^&#]*)";
    var regex = new RegExp(regexS);
    var results = regex.exec(url);
    return results == null ? null : results[1];
}

export default class SignupLightModel {
    constructor() {
        var emailValue = $("#email").val();
        this.email = ko.observable(emailValue)
            .extend({ required: { overrideMessage: "", active: false } })
            .extend({ serverCheck: { overrideMessage: "", active: false, url: "/Account/ValidateEmail", paramName: "email" } });
        this.password = ko.observable()
            .extend({ required: { overrideMessage: "", active: false } })
            .extend({ serverCheck: { overrideMessage: "", active: false, url: "/Account/ValidatePassword", paramName: "password" } });

        this.signupErrors = ko.observable();
        this.inProgress = ko.observable(false);

        this.agreedTermsConditions = ko.observable(false);
        this.agreedTermsConditionsError = ko.observable(false);

        this.googleUserId = null;

        this.plan = ko.observable(getQueryParam("plan"));
        this.isTest = ko.observable(getQueryParam("testmode"));

        const self = this;
        this.hasErrors = ko.computed(function() {
            return !!self.signupErrors();
        });

        this.agreedTermsConditions.subscribe(function(val) {
            self.agreedTermsConditionsError(false);
        });
    }

    disableSubmit() {
        this.inProgress(true);
    }

    enableSubmit() {
        this.inProgress(false);
    }

    signinRedirect() {
        Segment.track("Signup Light", { category: "Common", label: "Signin link clicked" });
        window.location.href = "/signin-light";
    }

    // From https://stackoverflow.com/a/38552302/596688
    // or use https://jwt.io/libraries?language=JavaScript
    decodeJwtResponse(token) {
        var base64Url = token.split('.')[1];
        var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
        var jsonPayload = decodeURIComponent(window.atob(base64).split('').map(function(c) {
            return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
        }).join(''));

        return JSON.parse(jsonPayload);
    };

    submitGoogleRegistration(credentialResponse) {
        Segment.track("Signup Light", { category: "Actions", label: "Signup started (google)" });

        this.email.deactivateRequiredValidation();
        this.email.deactivateServerCheckValidation();
        this.password.deactivateRequiredValidation();
        this.password.deactivateServerCheckValidation();

        const responsePayload = this.decodeJwtResponse(credentialResponse.credential);

        console.log("ID: " + responsePayload.sub);
        console.log('Full Name: ' + responsePayload.name);
        console.log('Given Name: ' + responsePayload.given_name);
        console.log('Family Name: ' + responsePayload.family_name);
        console.log("Image URL: " + responsePayload.picture);
        console.log("Email: " + responsePayload.email);

        const self = this;

        self.email(responsePayload.email);
        self.googleUserId = responsePayload.sub;

        this.doSignup();
    }

    doSignup() {
        const self = this;

        if (!this.agreedTermsConditions()) {
            this.agreedTermsConditionsError(true);
            self.enableSubmit();
            Segment.track("Signup Light", { category: "Actions", label: "Signup validation failed" });
            return;
        }

        self.signupErrors(null);
        self.disableSubmit();
        $.post("/signup-light", {
            email: self.email(),
            plan: self.plan(),
            googleUserId: self.googleUserId,
            password: self.password(),
            isTest: self.isTest()
        }).done((result) => {
            Segment.track("Signup Light", { category: "Actions", label: "Signup success" });
            window.location.href = result.RedirectTo;
        }).fail((data) => {
            Segment.track("Signup Light", { category: "Actions", label: "Signup failed" });
            const result = data.responseJSON || { ErrorMessage: "Unknown error has occurred, please try again or contact support" };
            //njoAppNotifier.notifyError(result.ErrorMessage, result.Description || "");
            console.log(result.ErrorMessage, result.Description || "");
            self.signupErrors(`${result.ErrorMessage} ${result.Description || ""}`);
            self.enableSubmit();
        });
    }

    signUp() {
        const self = this;

        Segment.track("Signup Light", { category: "Actions", label: "Signup started (form)" });

        self.disableSubmit();

        this.email.activateRequiredValidation();
        this.password.activateRequiredValidation();

        $.when(
            self.email.activateServerCheckValidation(),
            self.password.activateServerCheckValidation()
        ).done(function() {
            if (self.email.hasError() || self.password.hasError()) {
                self.email.deactivateServerCheckValidation();
                self.password.deactivateServerCheckValidation();

                Segment.track("Signup Light", { category: "Actions", label: "Signup validation failed" });

                self.enableSubmit();
                return;
            }

            self.doSignup();
        }).always(function() {
            //self.enableSubmit();
        });

    }
}

Segment.setEnvironment(config.isProduction);


window.signupModel = new SignupLightModel()

ko.applyBindings(window.signupModel, document.getElementById("njo-app"));

setTimeout(function() {
    Segment.track("Navigation", { category: "Page viewed", label: "Viewed Signup Light" });
}, 2000);